import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import styles from "./IndexPage.module.scss";
import React from "react";

export const IndexPage = () => {
  return (
    <>
      <SeoMetaTitles page="index" />
      <div className={styles.main}>
        <img src="/images/logo.svg" className={styles.image} />
      </div>
    </>
  );
};
